import React, { useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ReactComponent as ConfirmIcon } from '../../../assets/svg/ConfirmIcon.svg';
import {
    changeOblast,
    createNewKategorija,
    createNewOblast,
    createNewPodkategorija,
    createNewSkupOblasti,
    getKategorije,
    getOblastById,
    getPodkategorije,
    getPodkategorijeByKategorijaId,
    getSkupOblastiByPodkategorijaId,
    getSkupoviOblasti,
} from '../../../server/server-kategorije-tree';
import { notif } from '../../utils/util';
import Loading from '../../../utils/Loading';
import ImagesForm from '../../media/ImagesForm';

type Inputs = {
    naziv: string;
    opis: string;
    redosled: number | undefined;
};

function AddOblastModal({ modalIsOpen, closeModal, oblastId, reloadOblastiList }: any) {
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [kategorije, setKategorije] = useState<any>([]);
    const [podkategorijeAll, setPodkategorijeAll] = useState<any>([]);
    const [skupOblastiAll, setSkupOblastiAll] = useState<any>([]);
    const [selectedKategorija, setSelectedKategorija] = useState<any>(null);
    const [selectedPodkategorija, setSelectedPodkategorija] = useState<any>(null);
    const [selectedSkupOblasti, setSelectedSkupOblasti] = useState<any>(null);
    const [imagesList, setImagesList] = useState<any>([]);
    const [visible, setVisible] = useState(true);
    const [oblast, setoblast] = useState<any>(null);
    const {
        register,
        handleSubmit,
        watch,
        getValues,
        setValue,
        reset,
        formState: { errors },
    } = useForm<Inputs>({
        defaultValues: {
            naziv: '',
            opis: '',
            redosled: 0,
        },
    });

    useEffect(() => {
        if (!!oblastId) loadOblast();
    }, [oblastId]);

    const loadOblast = async () => {
        const resp = await getOblastById(oblastId);
        if (resp.status == 200) {
            setoblast(resp.data);
        }
    };

    useEffect(() => {
        if (modalIsOpen) {
            ReactModal.setAppElement('#root');
            loadKategorije();
            // loadPodkategorije();
            // loadSkupoviOblasti();
        }
    }, [modalIsOpen]);

    useEffect(() => {
        if (!!oblast?.id) {
            setValue('naziv', oblast?.naziv ?? '');
            setValue('opis', oblast?.opis ?? '');
            setValue('redosled', oblast?.redosled ?? 0);
            setVisible(oblast?.visible);
            if (oblast.kategorija) {
                setSelectedKategorija(oblast.kategorija);
                fetchSelectedDataByKategorijaId(oblast);
            }
            // if (oblast.podkategorija) setSelectedPodkategorija(oblast.podkategorija);
            // if (oblast.skupOblasti) setSelectedSkupOblasti(oblast.skupOblasti);
            if (oblast.oblastImages?.length) setImagesList(reorderImages(oblast.oblastImages));
        }
    }, [oblast]);

    const loadKategorije = async () => {
        const resp = await getKategorije();
        if (resp.status === 200) {
            setKategorije(resp.data);
        }
    };

    const fetchSelectedDataByKategorijaId = async (oblast: any) => {
        const resp = await getPodkategorijeByKategorijaId(oblast?.kategorija?.id);
        if (resp.status === 200) {
            setPodkategorijeAll(resp.data);
            if (oblast.podkategorija) {
                setSelectedPodkategorija(oblast.podkategorija);
                const resp = await getSkupOblastiByPodkategorijaId(oblast.podkategorija?.id);
                if (resp.status === 200) {
                    setSkupOblastiAll(resp.data);
                    if (oblast.skupOblasti) setSelectedSkupOblasti(oblast.skupOblasti);
                }
            }
        }
    };

    const changeVisibilty = () => {
        setVisible((prev) => !prev);
    };

    // const loadPodkategorije = async () => {
    // 	const resp = await getPodkategorije();
    // 	if (resp.status === 200) {
    // 		setPodkategorijeAll(resp.data);
    // 	}
    // };

    // const loadSkupoviOblasti = async () => {
    // 	const resp = await getSkupoviOblasti();
    // 	if (resp.status === 200) {
    // 		setSkupOblastiAll(resp.data);
    // 	}
    // };

    const reorderImages = (files: any) => {
        return !!files.length
            ? files.map((item: any) => {
                  return { id: item?.image?.id, redosled: item?.redosled };
              })
            : [];
    };

    const onSubmit: SubmitHandler<Inputs> = async () => {
        console.log('images list ', imagesList);
        if (!!oblast?.id) updateOblast();
        else {
            createOblast();
        }
    };
    const createOblast = async () => {
        setLoading(true);
        let data: any = getValues();
        data.redosled = getValues('redosled')?.toString();
        data.kategorijaId = selectedKategorija?.id ?? null;
        data.podkategorijaId = selectedPodkategorija?.id ?? null;
        data.skupOblastiId = selectedSkupOblasti?.id ?? null;
        data.visible = visible;
        if (imagesList.length) data.files = imagesList;
        const resp = await createNewOblast(data);
        if (resp.status == 201) {
            reloadOblastiList();
            notif('Uspešno ste kreirali novu oblast');
            setLoading(false);
            closeModal();
        } else {
            setLoading(false);
        }
    };
    const updateOblast = async () => {
        setLoading(true);
        let data: any = getValues();
        data.redosled = getValues('redosled')?.toString();
        data.id = oblast?.id;
        data.kategorijaId = selectedKategorija?.id ?? null;
        data.podkategorijaId = selectedPodkategorija?.id ?? null;
        data.skupOblastiId = selectedSkupOblasti?.id ?? null;
        data.visible = visible;
        if (imagesList.length) data.files = imagesList;
        const resp = await changeOblast(data);
        if (resp.status == 201) {
            reloadOblastiList();
            notif('Uspešno ste izmenili oblast');
            setLoading(false);
            closeModal();
        } else {
            setLoading(false);
        }
    };

    const handleSelectKategorije = (item: any) => {
        if (selectedKategorija !== null && selectedKategorija?.id === item?.id) {
            setSelectedKategorija(null);
            setSelectedPodkategorija(null);
            setSelectedSkupOblasti(null);
            setPodkategorijeAll([]);
            setSkupOblastiAll([]);
        } else if (selectedKategorija !== null && selectedKategorija?.id !== item?.id) {
            setSelectedKategorija(item);
            fetchPodkategorijeByKategorijaId(item.id);
            setSkupOblastiAll([]);
            setSelectedPodkategorija(null);
            setSelectedSkupOblasti(null);
        } else if (selectedKategorija === null) {
            setSelectedKategorija(item);
            fetchPodkategorijeByKategorijaId(item.id);
            setSkupOblastiAll([]);
            setSelectedPodkategorija(null);
            setSelectedSkupOblasti(null);
        }
    };

    const fetchPodkategorijeByKategorijaId = async (id: string) => {
        const resp = await getPodkategorijeByKategorijaId(id);
        if (resp.status === 200) {
            setPodkategorijeAll(resp.data);
        }
    };

    const handleSelectPodkategorija = (item: any) => {
        if (selectedPodkategorija !== null && selectedPodkategorija?.id === item?.id) {
            setSelectedPodkategorija(null);
            setSelectedSkupOblasti(null);
            setSkupOblastiAll([]);
        } else if (selectedPodkategorija !== null && selectedPodkategorija?.id !== item?.id) {
            setSelectedPodkategorija(item);
            fetchSkupOblasti(item?.id);
            setSelectedSkupOblasti(null);
        } else if (selectedPodkategorija === null) {
            setSelectedPodkategorija(item);
            fetchSkupOblasti(item?.id);
            setSelectedSkupOblasti(null);
        }
    };

    const fetchSkupOblasti = async (id: string) => {
        const resp = await getSkupOblastiByPodkategorijaId(id);
        if (resp.status === 200) {
            setSkupOblastiAll(resp.data);
        }
    };

    const handleSelectSkupOblasti = (item: any) => {
        if (selectedSkupOblasti !== null && selectedSkupOblasti?.id === item?.id) {
            setSelectedSkupOblasti(null);
        } else if (selectedSkupOblasti !== null && selectedSkupOblasti?.id !== item?.id) {
            setSelectedSkupOblasti(item);
        } else if (selectedSkupOblasti === null) {
            setSelectedSkupOblasti(item);
        }
    };

    const resetModal = () => {
        reset();
        setSelectedKategorija(null);
        setSelectedPodkategorija(null);
        setSelectedSkupOblasti(null);
        setKategorije([]);
        setPodkategorijeAll([]);
        setSkupOblastiAll([]);
        setVisible(true);
    };

    return (
        <ReactModal
            ariaHideApp={false}
            isOpen={modalIsOpen}
            onAfterOpen={() => {}}
            onAfterClose={() => resetModal()}
            onRequestClose={closeModal}
            className="no-scroll"
            style={{
                overlay: {
                    zIndex: 5,
                    backdropFilter: 'brightness(30%)',
                },
                content: {
                    padding: 0,
                    opacity: 1,
                    width: '100%',
                    maxWidth: 1400,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    height: '100%',
                    maxHeight: '100%',
                    border: 'none',
                    boxShadow: 'none',
                    overflow: 'auto',
                    paddingTop: 15,
                    paddingBottom: 15,
                },
            }}
        >
            <div className="h-full  w-full  bg-white rounded-[10px] p-3">
                <div className="grid grid-cols-5 gap-2 h-full">
                    <form
                        className="col-span-2 flex flex-col items-center w-full  pt-3  rounded-[10px] h-full overflow-auto"
                        onSubmit={handleSubmit(onSubmit)}
                        autoComplete="off"
                    >
                        <div className="flex flex-col w-full">
                            <label className="text-[16px] leading-5 text-black700 font-bold  ">Naziv oblasti</label>
                            <div className="bg-white border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center ">
                                <input
                                    className="text-[16px] leading-5 text-black700  w-full outline-none  placeholder:text-black200 "
                                    placeholder="Naziv oblasti"
                                    {...register('naziv', {
                                        validate: {
                                            obavezno: (value) => value.length > 0,
                                        },
                                    })}
                                />
                            </div>
                            <p className="text-redError text-[12px] leading-5 h-5 ">
                                <span>{errors.naziv?.type === 'obavezno' ? 'Obavezno popunite ovo polje!' : ''} </span>
                            </p>
                        </div>
                        <div className="flex flex-col w-full">
                            <label className="text-[16px] leading-5 text-black700 font-bold  ">Opis oblasti</label>
                            <div className="bg-white border border-black200 rounded-[4px] w-full px-3 py-2 flex flex-row items-center ">
                                <textarea
                                    rows={6}
                                    className="text-[16px] leading-5 text-black700  w-full outline-none  placeholder:text-black200 orange-tiny-scroll"
                                    placeholder="Opis oblasti"
                                    {...register('opis', {
                                        validate: {
                                            obavezno: (value) => value.length > 0,
                                        },
                                    })}
                                />
                            </div>
                            <p className="text-redError text-[12px] leading-5 h-5 ">
                                <span>{errors.opis?.type === 'obavezno' ? 'Obavezno popunite ovo polje!' : ''} </span>
                            </p>
                            <ImagesForm imagesList={imagesList} setImagesList={setImagesList} />
                        </div>
                        <div className="flex flex-col w-full">
                            <label className="text-[16px] leading-5 text-black700 font-bold  ">Redosled oblasti</label>
                            <div className="bg-white border border-black200 rounded-[4px] h-[48px] w-full px-3 flex flex-row items-center ">
                                <input
                                    className="text-[16px] leading-5 text-black700  w-full outline-none  placeholder:text-black200 "
                                    placeholder="Redosled oblasti"
                                    type="number"
                                    {...register('redosled', {
                                        min: 0,
                                    })}
                                />
                            </div>
                            <p className="text-redError text-[12px]  leading-5 h-5 ">
                                <span>{errors.redosled?.type === 'min' ? 'Vrednost mora biti pozitivan broj!' : ''} </span>
                            </p>
                        </div>
                        <div className="w-full">
                            <div className={`flex flex-row items-center cursor-pointer my-2`}>
                                <div
                                    className="border-[1.5px] border-black rounded-full h-[18px] w-[18px] flex items-center justify-center"
                                    onClick={() => changeVisibilty()}
                                >
                                    {visible && <div className="rounded-full h-[10px] w-[10px] bg-black"></div>}
                                </div>
                                <label className="text-black text-[16px] font-medium ml-[13px] cursor-pointer not-selectable">Oblast vidljiva</label>
                            </div>
                        </div>
                        <p className="text-redError text-[12px] leading-5 h-5 ">{!!errorMessage ? errorMessage : ''}</p>
                        <div className="w-full flex flex-row gap-5 justify-end">
                            <button
                                className={`px-5 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[18px] text-black700 font-bold cursor-pointer`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    closeModal();
                                }}
                            >
                                <p>Otkaži</p>
                            </button>
                            <button
                                type="submit"
                                className={`px-5 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[18px] text-black700 font-bold cursor-pointer`}
                                disabled={loading}
                            >
                                {loading ? (
                                    <Loading size={25} />
                                ) : (
                                    <div className="w-full flex flex-row items-center justify-center gap-3">
                                        <ConfirmIcon />
                                        <p>Potvrdi</p>
                                    </div>
                                )}
                            </button>
                        </div>
                    </form>
                    <div className="h-full overflow-auto bg-greyLight">
                        <div className="flex flex-row items-center  h-[50px]">
                            <label className="text-[16px] leading-5 text-black700 font-bold  ">
                                Lista postojećih kategorija <span>(ukupno {kategorije.length})</span>{' '}
                            </label>
                        </div>
                        {kategorije
                            .sort((a: any, b: any) => a.redosled - b.redosled)
                            .map((item: any, index: number) => {
                                return (
                                    <div
                                        className={` border border-black200 rounded-[4px] mb-1 p-2 flex flex-row items-center justify-between cursor-pointer ${
                                            item.id === selectedKategorija?.id ? 'bg-blueSuperLight' : 'bg-white'
                                        }`}
                                        key={index}
                                        onClick={() => handleSelectKategorije(item)}
                                    >
                                        <div>
                                            <p>
                                                Naziv: <span className="font-bold">{item.naziv}</span>
                                            </p>
                                            <p>Redosled: {item.redosled}</p>
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                    <div className="h-full overflow-auto bg-greyLight">
                        <div className="flex flex-row items-center  h-[50px]">
                            <label className="text-[16px] leading-5 text-black700 font-bold  ">
                                Lista postojećih podkategorija <span>(ukupno {podkategorijeAll.length})</span>{' '}
                            </label>
                        </div>
                        {podkategorijeAll.map((item: any, index: number) => {
                            return (
                                <div
                                    className={` border border-black200 rounded-[4px] mb-1 p-2 flex flex-row items-center justify-between cursor-pointer ${
                                        item.id === selectedPodkategorija?.id ? 'bg-blueSuperLight' : 'bg-white'
                                    }`}
                                    key={index}
                                    onClick={() => handleSelectPodkategorija(item)}
                                >
                                    <div>
                                        <p>
                                            Naziv: <span className="font-bold">{item.naziv}</span>
                                        </p>
                                        <p>Redosled: {item.redosled}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="h-full overflow-auto bg-greyLight	">
                        <div className="flex flex-row items-center  h-[50px]">
                            <label className="text-[16px] leading-5 text-black700 font-bold  ">
                                Lista postojećih skupova oblasti <span>(ukupno {skupOblastiAll.length})</span>{' '}
                            </label>
                        </div>
                        {skupOblastiAll.map((item: any, index: number) => {
                            return (
                                <div
                                    className={` border border-black200 rounded-[4px] mb-1 p-2 flex flex-row items-center justify-between cursor-pointer ${
                                        item.id === selectedSkupOblasti?.id ? 'bg-blueSuperLight' : 'bg-white'
                                    }`}
                                    key={index}
                                    onClick={() => handleSelectSkupOblasti(item)}
                                >
                                    <div>
                                        <p>
                                            Naziv: <span className="font-bold">{item.naziv}</span>
                                        </p>
                                        <p>Redosled: {item.redosled}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </ReactModal>
    );
}

export default AddOblastModal;
